import NutritionProfileEditor from "./NutritionProfileEditor";

export default function MyNutrition() {
  return <NutritionProfileEditor mode="client" />;
}
